<template>
  <!-- 供应链统计 -->
  <div>
    <!-- 头部-->
    <div class="child-head">
      <!-- 标题 -->
      <div class="child-head-left float-l">
        <img src="../../assets/area_title.png" class="head-img">
        <span>供应链统计</span>
      </div>
      <!-- tab选项 -->
      <div class="child-head-right float-r">
        <div @click="selTab(0)" :class="tabIndex == 0 ? 'border-tab' : ''">今日</div>
        <div @click="selTab(1)" :class="tabIndex == 1 ? 'border-tab' : ''">维修</div>
        <div @click="selTab(2)" :class="tabIndex == 2 ? 'border-tab' : ''">加油</div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="content content-chunk-box">
      <!-- 边角 -->
      <contentCorner>
        <!-- 内容 -->
        <div class="content-div">

          <!-- 总计 -->
          <div v-show="tabIndex == 0" class="content-div-1">
            <div>
              <div class="content-div-1-1">
                <div style="position: relative;margin-right: 15px;">
                  <div class="bg-svg">
                  </div>
                  <div class="svg-file">
                    <svg-icon icon-file-name="u43" style=" font-size: 55px;" />
                  </div>

                </div>

                <div>
                  <div>维修（次/万）</div>
                  <div class="Count-text">{{ formatNumberNoW(totalMaintenanceCount) }}</div>
                </div>
              </div>
              <div class="content-div-1-1">
                <div style="position: relative;margin-right: 15px;">
                  <div class="bg-svg">
                  </div>
                  <div class="svg-file">
                    <svg-icon icon-file-name="u43" style=" font-size: 55px;" />
                  </div>

                </div>
                <div>
                  <div>维修（万元）</div>
                  <div class="Count-text">{{ formatNumberNoW(totalMaintenanceFee) }}</div>
                </div>
              </div>
            </div>
            <div>
              <div class="content-div-1-1">
                <div style="position: relative;margin-right: 15px;">
                  <div class="bg-svg">
                  </div>
                  <div class="svg-file-1">
                    <svg-icon icon-file-name="u52" style=" font-size: 40px;" />
                  </div>

                </div>
                <div>
                  <div>加油（万升）</div>
                  <div class="Count-text">{{ formatNumberNoW(totalOilVolumn) }}</div>
                </div>
              </div>

              <div class="content-div-1-1">
                <div style="position: relative;margin-right: 15px;">
                  <div class="bg-svg">
                  </div>
                  <div class="svg-file-1">
                    <svg-icon icon-file-name="u52" style=" font-size: 40px;" />
                  </div>

                </div>
                <div>
                  <div>加油（万元）</div>
                  <div class="Count-text">{{ formatNumberNoW(totalOilFee) }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 维修 -->
          <div v-if="tabIndex == 1" class="content-div-2">
            <dv-scroll-board class="dv-scr-board" :config="maintainConfig" />
          </div>
          <!-- 加油 -->
          <div v-if="tabIndex == 2" class="content-div-2">
            <dv-scroll-board class="dv-scr-board" :config="refuelConfig" />
          </div>
        </div>
      </contentCorner>
    </div>
  </div>
</template>
<script>
import contentCorner from '../../components/common/contentCorner.vue';
import { getSupplyChain } from '../../api/holdMy';

export default {

  data() {
    return {
      refreshTabing: null,
      tabIndex: 0,    // tab下标
      maintainConfig: {
        header: ['城市', '今日维修', '总计维修'],
        data: [],
        rowNum: 5, //表格行数
        headerHeight: 35,
        headerBGC: 'rgba(26, 201, 255, 0.2980392156862745)', //表头
        oddRowBGC: 'rgba(26, 201, 255, 0)', //奇数行
        evenRowBGC: 'rgba(26, 201, 255, 0', //偶数行
        align: ['left', 'left', 'left'],
        columnWidth: [90, 200, 220],
      },
      refuelConfig: {
        header: ['城市', '今日加油', '总计加油'],
        data: [],
        rowNum: 5, //表格行数
        headerHeight: 35,
        headerBGC: 'rgba(26, 201, 255, 0.2980392156862745)', //表头
        oddRowBGC: 'rgba(26, 201, 255, 0)', //奇数行
        evenRowBGC: 'rgba(26, 201, 255, 0', //偶数行
        align: ['left', 'left', 'left'],
        columnWidth: [90, 200, 220],
      },
      totalOilVolumn: '',
      totalOilFee: '',
      totalMaintenanceCount: '',
      totalMaintenanceFee: '',
    }
  },
  components: { contentCorner },
  created() {
    this.refreshTab();
    this.getSupplyChain();
  },
  mounted() {

  },
  beforeDestroy() {
    clearInterval(this.refreshTabing);
  },
  methods: {
    // 自动切换tab 3 分钟
    refreshTab() {
      if (this.refreshTabing) {
        clearInterval(this.refreshTabing);
      }
      this.refreshTabing = setInterval(() => {
        var index = this.tabIndex + 1;
        if (index > 2) {
          index = 0
        }
        this.tabIndex = index;
        this.selTab(this.tabIndex)
      }, 1000 * 60 * 3)
    },
    // 切换tab
    selTab(index) {
      this.tabIndex = index;
      this.getSupplyChain();
    },
    getSupplyChain() {
      getSupplyChain({}).then(res => {
        if (res.result == 0) {
          this.totalOilFee = res.userdata.totalOilFee || 0;
          this.totalOilVolumn = res.userdata.totalOilVolumn || 0;
          this.totalMaintenanceCount = res.userdata.totalMaintenanceCount || 0;
          this.totalMaintenanceFee = res.userdata.totalMaintenanceFee || 0;
          // 维修
          let oilListGroupRepairList = res.userdata.oilListGroupRepair || [];
          // 加油
          let oilListGroupCityList = res.userdata.oilListGroupCity || [];

          this.$nextTick(() => {
            this.setData1(oilListGroupCityList);
            this.setData2(oilListGroupRepairList);
          })

          // this.todayTransportRequirementCount = res.userdata.todayTransportRequirementCount?res.userdata.todayTransportRequirementCount:0;
          // this.totalCount = res.userdata.totalCount || 0;

        }
      }).catch(error => {
        console.log(error);
      })
    },
    // 加油
    setData1(list) {
      var a = 100;
      let data1 = [];
      if (list != null && list.length > 0) {
        var maxTodayOilFee = Math.max.apply(Math, list.map(item => {
          return item.todayOilFee
        }))
        var maxTotalOilFee = Math.max.apply(Math, list.map(item => {
          return item.totalOilFee
        }))
        list.forEach(item => {
          data1.push([item.city, `<meter min="0" max="${maxTodayOilFee}" value="${item.todayOilFee ? item.todayOilFee : 0}"></meter><span>${item.todayOilFee ? this.formatNumber(item.todayOilFee) : '0万'}</span>`, `<meter min="0" max="${maxTotalOilFee}" value="${item.totalOilFee ? item.totalOilFee : 0}"></meter><span>${item.totalOilFee ? this.formatNumber(item.totalOilFee) : '0万'}</span>`]);
        })
        this.refuelConfig.data = data1;
        this.refuelConfig = { ...this.refuelConfig };
      }
      // this.refuelConfig.data = [
      //     ['行1列1', `<meter min="0" max="500" value="${a}"></meter><span>${a}</span>`, `<meter min="0" max="500" value="${a}"></meter><span>${a}</span>`],
      //     ['行2列1', `<meter min="0" max="500" value="${a}"></meter><span>${a}</span>`, `<meter min="0" max="500" value="${a}"></meter><span>${a}</span>`],
      //     ['行3列1', `<meter min="0" max="500" value="${a}"></meter><span>${a}</span>`, `<meter min="0" max="500" value="${a}"></meter><span>${a}</span>`],
      //     ['行4列1', `<meter min="0" max="500" value="${a}"></meter><span>${a}</span>`, `<meter min="0" max="500" value="${a}"></meter><span>${a}</span>`],
      //     ['行5列1', `<meter min="0" max="500" value="${a}"></meter><span>${a}</span>`, `<meter min="0" max="500" value="${a}"></meter><span>${a}</span>`],
      //     ['行5列1', `<meter min="0" max="500" value="${a}"></meter><span>${a}</span>`, `<meter min="0" max="500" value="${a}"></meter><span>${a}</span>`],
      //     ['行5列1', `<meter min="0" max="500" value="${a}"></meter><span>${a}</span>`, `<meter min="0" max="500" value="${a}"></meter><span>${a}</span>`]
      // ]
      // this.refuelConfig = { ...this.refuelConfig };//关键,展开数组对象重新赋值.不写数据出不来
    },
    // 加油
    setData2(list) {
      let data1 = [];
      if (list != null && list.length > 0) {
        var maxTodayMaintenanceFee = Math.max.apply(Math, list.map(item => {
          return item.todayMaintenanceFee
        }))
        var maxTotalMaintenanceFee = Math.max.apply(Math, list.map(item => {
          return item.totalMaintenanceFee
        }))
        list.forEach(item => {
          data1.push([item.city, `<meter min="0" max="${maxTodayMaintenanceFee}" value="${item.todayMaintenanceFee ? item.todayMaintenanceFee : 0}"></meter><span>${item.todayMaintenanceFee ? this.formatNumber(item.todayMaintenanceFee) : '0万'}</span>`, `<meter min="0" max="${maxTotalMaintenanceFee}" value="${item.totalMaintenanceFee ? item.totalMaintenanceFee : 0}"></meter><span>${item.totalMaintenanceFee ? this.formatNumber(item.totalMaintenanceFee) : '0万'}</span>`]);
        })
        this.maintainConfig.data = data1;
        this.maintainConfig = { ...this.maintainConfig };
      }
    },
    formatNumber(num) {
      num = Number(num);
      return (num / 10000).toFixed(2) + '万';
    },
    formatNumberNoW(num) {
      num = Number(num);
      return (num / 10000).toFixed(2);
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 233px;
  width: 100%;

  .content-div {
    padding: 10px 20px;
  }

  .content-div-1 {
    padding: 5px 10px;
    display: flex;
    align-content: center;
    justify-content: center;

    .content-div-1-1 {
      width: 190px;
      // height: 75px;
      display: flex;
      align-content: center;
      justify-content: center;
      font-family: '微软雅黑', sans-serif;
      font-weight: 400;
      font-style: normal;
      color: #FFFFFF;
      font-size: 16px;
      margin: 25px 10px;

    }
  }

  .Count-text {
    font-size: 28px;
    font-family: 'Impact Normal', 'Impact', sans-serif;
    font-weight: 400;
    color: #44EFFF;
    margin-top: 10px;
  }

  .svg-file {
    position: absolute;
    top: 7%;
    left: 8%;
  }

  .svg-file-1 {
    position: absolute;
    top: 18%;
    left: 24%;
  }

  .bg-svg {
    background-image: url("../../assets/ditu.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: block;
    width: 65px;
    height: 65px;
    -webkit-animation: rotation 4s linear infinite;
    animation: rotation 4s linear infinite;
  }

  @keyframes rotation {
    0% {
      -webkit-transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  .content-div-2 {
    overflow: hidden;
    height: 210px;
    width: 460px;

    .dv-scr-board {
      width: 460px;
      height: 200px;
      font-size: 25px;
    }
  }
}

::v-deep .city-box .dv-scr-board .header {
  color: #b2b2b2 !important;

}
</style>
<style>
meter {
  width: 100px;
  margin-right: 10px;
  height: 17px;
  border-radius: 5px;
  box-sizing: border-box;
  -webkit-transform-origin: center 8px;
}

meter::-webkit-meter-optimum-value {

  background-color: #31A7FF;
}

meter::-webkit-meter-bar {
  background: rgba(10, 51, 126);
}
</style>